module.exports = __webpack_public_path__ + "img/Icon-Haefele.af20bcf9.svg";